import {isNil, queryStringValue} from "../Helper";

export default function faqGroupAccordion() {

    const faqItemIdentifier = queryStringValue('faqItem');
    const accordionItem = document.querySelector('#collapse_' + faqItemIdentifier);

    if (!isNil(accordionItem)) {
      accordionItem.classList.toggle('show');
      accordionItem.parentNode.classList.toggle('highlight');
      accordionItem.scrollIntoView();
    }

}
